import { render } from "./index-2.vue?vue&type=template&id=51eb7d7f"
import script from "./index-2.vue?vue&type=script&lang=js"
export * from "./index-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__